class Forms {

  // Private originalData field
  #originalData

  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor(data) {
    this.#originalData = data;
    for (const field in data) {
      this[field] = data[field];
    }
    this.loading = false;
  }

  /**
   * Fetch all relevant data for the form.
   */
  data() {
    const data = {};
    for (const property in this.#originalData) {
      data[property] = this[property];
    }
    return JSON.parse(JSON.stringify(data));
  }

  /**
   * Set value on given field
   *
   * @param {string} field
   * @param {string} value
   */
  set(field, value) {
    this[field] = value;
  }

  /**
   * Reset the form fields.
   */
  reset() {
    for (const field in this.#originalData) {
      this[field] = this.#originalData[field];
    }
  }

}

export default Forms;
